
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/DeleteGroup';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n            <option class=\"move_to_ag_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" value=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n          ";
  return buffer;
  }

  buffer += "<div class=\"form-dialog-content\">\n  <div class=\"form-horizontal\">\n    <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'assignment_count': ((depth0 && depth0.assignment_count)),
    'w0': ("<strong>$1</strong>"),
    'w1': ("<strong class=\"assignment_count\">$1</strong>"),
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.warnings.delete_assignment_group", "You are about to delete *%{name}*, which has **%{assignment_count}** assignments in it.", options) : helperMissing.call(depth0, "t", "assignments.delete_group.warnings.delete_assignment_group", "You are about to delete *%{name}*, which has **%{assignment_count}** assignments in it.", options)))
    + "\n    </p>\n      <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.would_you_like", "Would you like to:", options) : helperMissing.call(depth0, "t", "assignments.delete_group.would_you_like", "Would you like to:", options)))
    + "</p>\n    <p>\n      <label class=\"radio\"><input type=\"radio\" class=\"assignment_group_delete\" name=\"action\" value=\"delete\" checked=\"checked\"/> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.labels.delete_assignments_in_group", "Delete its assignments", options) : helperMissing.call(depth0, "t", "assignments.delete_group.labels.delete_assignments_in_group", "Delete its assignments", options)))
    + "</label>\n    </p>\n    <p>\n      <label id=\"ag_move_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"radio\"><input type=\"radio\" class=\"assignment_group_move\" name=\"action\" value=\"move\"/> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.labels.move_assignments_to", "Move its assignments to", options) : helperMissing.call(depth0, "t", "assignments.delete_group.labels.move_assignments_to", "Move its assignments to", options)))
    + "</label>\n      <div id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_move_assignments_to_container\" class=\"group_select_container\">\n        <select name=\"move_assignments_to\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.tooltips.target_group", "Select a group to move this assignment to", options) : helperMissing.call(depth0, "t", "assignments.delete_group.tooltips.target_group", "Select a group to move this assignment to", options)))
    + "\" aria-labelledby=\"ag_move_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-describedby=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_move_assignments_to_errors\" class=\"group_select\">\n          <option value=\"\" class=\"blank\">[ "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.options.select_group", "Select a Group", options) : helperMissing.call(depth0, "t", "assignments.delete_group.options.select_group", "Select a Group", options)))
    + " ]</option>\n          ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.groups), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </select>\n      </div>\n      <div id=\"ag_";
  if (helper = helpers.label_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.label_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_move_assignments_to_errors\"></div>\n    </p>\n  </div>\n</div>\n<div class=\"form-controls\">\n  <button\n    class=\"cancel_button btn dialog_closer\"\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "assignments.delete_group.cancel", "Cancel", options)))
    + "</button>\n  <button\n    class=\"delete_group btn btn-primary\" type=\"submit\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.deleting", "Deleting...", options) : helperMissing.call(depth0, "t", "assignments.delete_group.deleting", "Deleting...", options)))
    + "'\n    type=\"button\"\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.delete_group")
  },data:data},helper ? helper.call(depth0, "assignments.delete_group.delete", "Delete Group", options) : helperMissing.call(depth0, "t", "assignments.delete_group.delete", "Delete Group", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  